import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderRadius,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Row = styled.div<{
  $clickable?: boolean;
  $hideBorder?: boolean;
  $isOpen?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
  min-height: 50px;
  padding: ${({ $clickable, $isOpen }) =>
    $clickable && $isOpen
      ? `${spacing[3]} ${spacing[3]} 0`
      : spacing[3]};
  border-bottom: ${({ $hideBorder }) =>
    $hideBorder ? "none" : `${borderWidth[1]} solid ${rawColors.stroke[200]}`};
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};

  &:hover {
    background-color: ${({ $clickable }) =>
      $clickable ? rawColors.structural[50] : "transparent"};
  }
`;

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
  flex: 0 1 auto;
  
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${rawColors.text.mediumEmphasis};
  flex-shrink: 0;
`;

export const Label = styled.span<{ $active?: boolean }>`
  ${({ $active }) => typographyMixin("caption", $active ? 3 : 4)}
  color: ${({ $active }) =>
    $active ? rawColors.text.highEmphasis : rawColors.text.mediumEmphasis};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const ValueSlot = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  flex-shrink: 0;
  margin-left: auto;
`;

export const Chevron = styled.span<{ $isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${rawColors.text.mediumEmphasis};
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")});
`;
